import React from 'react';
import {useTranslation} from 'react-i18next';
import EventDateTime from '../../components/EventDateTime/EventDateTime';
import TicketQr from '../../components/TicketQr/TicketQr';
import {TEticketEvent} from '../../../../redux/eTicket/eTicket.type';
import * as css from './TicketDetailsBody.css';

interface TicketDetailsBodyProps {
    event: TEticketEvent;
    barcode: string;
    qid: number;
    index: number;
    total: number;
    onQrZoom: () => void;
}

function TicketDetailsBody({event, barcode, qid, index, total, onQrZoom}: TicketDetailsBodyProps) {
    const {t} = useTranslation('eTicket');

    return (
        <css.body>
            <css.title>{event.title}</css.title>
            <EventDateTime event={event} />
            <TicketQr barcode={barcode} onZoom={onQrZoom} />
            <css.ticketNo data-cy="ticket-counter">
                {t('ticketCounter', {current: index + 1, total})}
                {' • '} {qid}
            </css.ticketNo>
        </css.body>
    );
}

export default TicketDetailsBody;
